import { FeeModel, TicketModel } from '@/v2/models/ticketModel';
import { EnvelopeFeeDisplayType, MultiEventEnvelopeModel } from '@/v2/models/multiEventEnvelopeModel';

export function getSingleFee(envelope: MultiEventEnvelopeModel, ticket: TicketModel) {
  return +ticket.fee + envelope.otherFees / envelope.eventTickets.reduce((sum, e) => sum + e.tickets.length, 0);
}

export function getShouldDisplayTaxes(envelopeFeeDisplayType: EnvelopeFeeDisplayType, ticket: TicketModel) {
  return envelopeFeeDisplayType !== EnvelopeFeeDisplayType.ROLLED_UP && isGreaterThanZero(ticket.tax);
}

export function getShouldDisplayCompleteBreakdown(
  envelopeFeeDisplayType: EnvelopeFeeDisplayType,
  fees: FeeModel[],
): boolean {
  return (
    envelopeFeeDisplayType === EnvelopeFeeDisplayType.COMPLETE_BREAKDOWN &&
    fees &&
    containsGreaterThanZero(fees.map((fee) => fee.value))
  );
}

export function getShouldDisplaySingleFee(
  envelopeFeeDisplayType: EnvelopeFeeDisplayType,
  singleFee: number,
  fees: FeeModel[],
): boolean {
  if (!isGreaterThanZero(singleFee)) {
    return false;
  }

  if (envelopeFeeDisplayType === EnvelopeFeeDisplayType.SINGLE_LINE) {
    return true;
  }

  if (envelopeFeeDisplayType === EnvelopeFeeDisplayType.COMPLETE_BREAKDOWN) {
    return !fees || !containsGreaterThanZero(fees.map((fee) => fee.value));
  }

  return false;
}

function isGreaterThanZero(input: number): boolean {
  return input != null && input > 0;
}

function containsGreaterThanZero(input: number[]): boolean {
  return input.some((num) => num != null && num > 0);
}
